import _ from "lodash";
import ACTIONS from "../veritas-report-gen/ReportGeneratorActions";

const sourceTypeOptions = require("../../common/resources/sourcetypes.json")


const initialState = {
    veritasSelectedSources: [],
    displayVeritasSourcesPDFReport: false,
    dpInputFields: [],
}

const pdfReportGenReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.Reports.RESET_PDF_PORTAL: {
            let newState = _.cloneDeep(state);
            newState.displayVeritasSourcesPDFReport = initialState.displayVeritasSourcesPDFReport;
            return newState;
        }

        case ACTIONS.Reports.PDF_REPORT_SUCCESS: {
            let newState = _.cloneDeep(state);
            // toggle the portal display trigger.
            newState.displayVeritasSourcesPDFReport = !newState.displayVeritasSourcesPDFReport;

            newState.veritasSelectedSources = action.payload.report;
            newState.dpInputFields = action.payload.inputFields;

            // adjust the source data for each source
            newState.veritasSelectedSources.forEach((source, idx) => {
                // parse the required inputs acc to the group-id so we can render it
                // in the report as inputs of that group
                const requried_inputs_with_id = source.required_inputs.split(",");

                // we are changing the data structure that builds the required inputs into the report
                // since we have country specific structure, we are now using a js object with keys of countries
                // and nested inside of them another dict with keys mapped to input group id and value as the
                // identity elements.
                // query returns a value like 'AR:0:Input Element 1, AR:1:Input Element 2, ZZ:0:Input Element 4
                let req_ip = {}
                requried_inputs_with_id.forEach(i => {
                    const group = i.split(":")
                    const group_country = group[0]
                    const group_index = group[1]
                    const group_label = group[2]
                    if(req_ip[group_country]) {
                        if (req_ip[group_country][group_index]) {
                            req_ip[group_country][group_index].push(group_label)
                        } else {
                            req_ip[group_country][group_index] = [];
                            req_ip[group_country][group_index].push(group_label)
                        }
                    } else {
                        req_ip[group_country] = {};
                        req_ip[group_country][group_index] = [];
                        req_ip[group_country][group_index].push(group_label)
                    }
                });
                source.required_inputs = req_ip

                // format the verifiable inputs to a comma-separated array
                // if null, set to an empty array.
                if (source.verifiable_inputs !== null) {
                    source.verifiable_inputs = source.verifiable_inputs.split(",")
                } else {
                    source.verifiable_inputs = []
                }

                // format the source type, which is a 3-letter value to the label
                source.source_type = _.result(_.find(sourceTypeOptions, {
                    value: source.source_type
                }), "label");
            });

            // setting the value back to true
            // as this action is fired, the portal should open.
            if (!newState.displayVeritasSourcesPDFReport) {
                newState.displayVeritasSourcesPDFReport = !newState.displayVeritasSourcesPDFReport;
            }

            return newState;
        }

        default:
            return state;
    }
}

export default pdfReportGenReducer;
